export type FloatPanelElevation = 1 | 2 | 3 | 4;

export interface FloatPanelProps {
	elevation?: FloatPanelElevation;
	padding?: number | string;
	children: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

const elevationShadowMap: Record<FloatPanelElevation, string> = {
	1: "var(--dashboard-shadow-1)",
	2: "var(--dashboard-shadow-2)",
	3: "var(--dashboard-shadow-3)",
	4: "var(--dashboard-shadow-4)",
};

export function FloatPanel({
	elevation = 1,
	padding = 20,
	children,
	className,
	style,
}: FloatPanelProps) {
	return (
		<div
			className={className}
			style={{
				background: "var(--color-dashboard-paper)",
				border: "1px solid var(--color-dashboard-border)",
				borderRadius: 13,
				padding,
				boxShadow: elevationShadowMap[elevation],
				...style,
			}}
		>
			{children}
		</div>
	);
}
